import { render, staticRenderFns } from "./GenerateRenewed.vue?vue&type=template&id=6f4ef7c2&scoped=true&"
import script from "./GenerateRenewed.vue?vue&type=script&lang=js&"
export * from "./GenerateRenewed.vue?vue&type=script&lang=js&"
import style0 from "./GenerateRenewed.vue?vue&type=style&index=0&id=6f4ef7c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ef7c2",
  null
  
)

export default component.exports